import { execute_generator } from './index'

const root = '/devices'
const messages_root = '/messages'
const alert_root = '/alerts'

const device_url = process.env.VUE_APP_API_DEVICE_URL
const messages_url = process.env.VUE_APP_API_MESSAGE_URL
const alert_url = process.env.VUE_APP_API_ALERT_URL

export const device_requests = {
    devicesByAccount: ({account_id}) => execute_generator(
        'GET', 
        { service: device_url, resource:`${root}/byacct/${account_id}`}
    )
}

export const sensor_requests = {
    sensorsByDevice: ({device_id}) => execute_generator(
        'GET', 
        { service: device_url, resource:`${root}/sensors/bydevice/${device_id}`}
    )
}

export const get_devices_and_sensors = account_id => execute_generator(
    'GET',
    { service: device_url, resource: `${root}/byacct/${account_id}/sensors` }
)

export const update_device = body => execute_generator(
    'PUT',
    { service: device_url, resource:`${root}/name/${body.id}` },
    body
)

export const update_sensor_gpm = body => execute_generator(
    'PUT',
    { service: device_url, resource:`${root}/sensors/${body.podid}/gpm` },
    body
)

export const get_sensor_data = body => execute_generator(
    'POST', { service: messages_url, resource:`${messages_root}/dashboard/sensor`}, body
)

export const get_cropdr_sensor_data = body => execute_generator(
    'POST', { service: messages_url, resource:`${messages_root}/dashboard/cropdr/sensor`}, body
)

export const get_alerts_by_sensor_id = podId => execute_generator(
    'POST',
    { service: alert_url, resource: `${alert_root}/search/violations`},
    { podId: podId }
)

export const get_sensor_summary = body => execute_generator(
    'POST', { service: messages_url, resource: `${messages_root}/sensordata/daily`}, body
)

export const get_sensor_flow_plot = body => execute_generator(
    'POST', { service: messages_url, resource: `${messages_root}/sensordata/flowplot`}, body
)

export const get_hourly_sensor_summary = podid => execute_generator(
    'GET',
    { service: messages_url, resource: `${messages_root}/sensordata/hourly/${podid}` }
)

export const get_hourly_sensor_summary_bydate = body => execute_generator(
    'POST', { service: messages_url, resource: `${messages_root}/sensordata/hourly` }, body
)

export const get_plans = () => execute_generator(
    'GET', { service: device_url, resource: `${root}/plans/available?pricingTable=true` }
).next()

export const get_device_detail = id => execute_generator(
    'GET',
    { service: device_url, resource: `${root}/detail/${id}` }
)

export const update_device_address = body => execute_generator(
    'PUT',
    { service: device_url, resource: `${root}/address` },
    body
)

export const create_device_address = body => execute_generator(
    'POST',
    { service: device_url, resource: `${root}/address` },
    body
)

export const get_device_by_imei = imei => execute_generator(
    'GET', { service: device_url, resource: `${root}/self/by/imei/${imei}` }
).next()


